import { MaterialReactTable } from "material-react-table";
import React, { useMemo, useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Tooltip,
    Box,
    CircularProgress,
    Typography,
} from "@mui/material";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { RemoveIcon } from "../../../assets/images";
import { Modal } from "react-bootstrap";
import AlertTemplateMessage from "../../Configuration/AlertTemplate/AlertTemplateMessage";

import VideocamIcon from "@mui/icons-material/Videocam";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import ListAltIcon from "@mui/icons-material/ListAlt";
import NetworkCheckIcon from "@mui/icons-material/NetworkCheck";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import SettingsIcon from "@mui/icons-material/Settings";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CancelIcon from "@mui/icons-material/Cancel";
import { ErrorToast } from "../../../CustomHooks/ErrorToast";
import { getDiscoverDeviceList } from "../../../services/onVifService";
import { SuccessToast } from "../../../CustomHooks/SuccessToast";

const InterfaceDiscoverConfig = ({ setShowInterfaceDiscoverForm }) => {
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showAdditionalModal, setShowAdditionalModal] = useState(false);
    const [isDiscoverLoading, setIsDiscoverLoading] = useState(false);
    const [discoverDeviceList, setDiscoverDeviceList] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    console.log("discoverDeviceList", discoverDeviceList);

    //  const data = [
    //     { id: 1, ip: "192.168.1.1", port: 80, deviceName: "Device name-01", type: "Camera", manufacture: "Intellve" },
    //     { id: 2, ip: "192.168.1.2", port: 443, deviceName: "Device name-02", type: "Camera", manufacture: "Intellve" },
    //     { id: 3, ip: "192.168.1.3", port: 22, deviceName: "Device name-03", type: "Camera", manufacture: "Intellve" },
    //     { id: 4, ip: "192.168.1.4", port: 53, deviceName: "Device name-04", type: "Camera", manufacture: "Intellve" },
    //     { id: 5, ip: "192.168.1.5", port: 3389, deviceName: "Device name-05", type: "Camera", manufacture: "Intellve" },
    //     { id: 6, ip: "192.168.1.6", port: 8080, deviceName: "Device name-06", type:"Camera", manufacture:"Intellve" },
    // ];
    const data =
        discoverDeviceList && Array.isArray(discoverDeviceList)
            ? discoverDeviceList
            : [];
    const columns = useMemo(
        () => [
            {
                accessorKey: "IP",
                header: "IP",
                size: 250,
            },
            {
                accessorKey: "Port",
                header: "Port",
                size: 200,
            },
            {
                accessorKey: "Name",
                header: "Device name",
                size: 300,
            },
            {
                accessorKey: "Type",
                header: "Type",
                size: 300,
                Cell: ({ cell }) =>
                    Array.isArray(cell.getValue())
                        ? cell.getValue().join(", ")
                        : cell.getValue(),
            },
            {
                accessorKey: "Hardware",
                header: "Hardware",
                size: 300,
            },
            {
                accessorKey: "DeviceType",
                header: "Device Type",
                size: 300,
            },
            {
                accessorKey: "Profiles",
                header: "Profiles",
                size: 300,
                Cell: ({ cell }) =>
                    Array.isArray(cell.getValue())
                        ? cell.getValue().join(", ")
                        : cell.getValue() || "-",
            },

            {
                id: "actions",
                header: "Actions",
                size: 200,
                Cell: ({ row }) => (
                    <Box sx={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}>
                     <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={showModel}
                        >
                            Get Additional Info
                        </Button>
                    </Box>
                ),
                muiTableHeadCellProps: {
                    sx: {
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#1976d2",
                    color: "white",
                    fontWeight: "bold",
                    zIndex: 3,
                    textAlign: "center",
                    },
                },
                muiTableBodyCellProps: {
                    sx: {
                    position: "sticky",
                    right: 0,
                    zIndex: 2,
                    textAlign: "center",
                    },
                },
            },
            // {
            //     id: "actions",
            //     header: "Actions",
            //     size: 300,
            //     Cell: ({ row }) => (
            //         <Box
            //             sx={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}
            //         >
            //             <Button
            //                 variant="outlined"
            //                 color="primary"
            //                 size="small"
            //                 onClick={showModel}
            //             >
            //                 Get Additional Info
            //             </Button>
            //         </Box>
            //     ),
            //    muiTableHeadCellProps: {
            //         sx: {
            //             position: "sticky",
            //             right: 0,
            //             zIndex: 20,
            //             backgroundColor: "#1976d2",
            //             color: "#fff",
            //             boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.2)",
            //         },
            //     },
            //     muiTableBodyCellProps: {
            //         sx: {
            //             position: "sticky",
            //             right: 0,
            //             zIndex: 10,
            //             backgroundColor: "#fff",
            //             boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.1)",
            //         },
            //     },
            // },
        ],
        [],
    );

    const showDiscoverInterfaceForm = async () => {
        // show both loading flags so UI can reflect discovery in progress
        setLoading(true);
        //setIsDiscoverLoading(true);
        try {
            const response = await getDiscoverDeviceList();
            if (response && response.Status === "success") {
                setDiscoverDeviceList(response.Data);
                SuccessToast("Device Discover Successfully");
                setShowInterfaceDiscoverForm(true);
            } else {
                setDiscoverDeviceList([]);
                ErrorToast("Device Discover Failed");
            }
        } catch (err) {
            console.log(err);
            ErrorToast("Error discovering devices");
        } finally {
            //setIsDiscoverLoading(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        showDiscoverInterfaceForm();
    }, []);

    const showModel = () => {
        setShowAdditionalModal(true);
    };

    return (
        <div className="SiteMainContainer SiteTableMainDiv">
            <div className="p-2 d-flex align-items-center gap-2">
                <button
                    style={{ background: "#1268ce", borderRadius: "4px" }}
                    title="Go back"
                    onClick={() => setShowInterfaceDiscoverForm(false)}
                >
                    <ArrowBackIosRoundedIcon className="w-5 h-5 text-white" />
                </button>
                {/* <h5 className="ml-2 mb-0">Discover Devices configuration</h5> */}
                <Typography variant="h6" sx={{ fontWeight: 600, ml: 0.5 }}>
                    Discover Devices configuration
                </Typography>

                <Box sx={{ flex: 1 }} />

                <Button
                    variant="outlined"
                    size="small"
                    onClick={showDiscoverInterfaceForm}
                    disabled={loading}
                >
                    Refresh
                </Button>
            </div>

            <div className="SiteMainHeightDiv">
                {loading ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        minHeight="400px"
                        flexDirection="column"
                    >
                        <CircularProgress size={60} thickness={4} />
                        <Box mt={2}>
                            <span style={{ fontSize: '16px', color: '#666' }}>
                                Discovering devices...
                            </span>
                        </Box>
                    </Box>
                ) : (
                    <div
                        className="col-lg-12 m-0 TabulerReportMainDiv MatReactTableDiv"
                        style={{ height: "calc(100vh - 210px)" }}
                    >
                        {/* <MaterialReactTable
                            columns={columns}
                            data={data}
                            // initialState={{ showColumnFilters: false }}

                            checkboxSelection={true}
                            enableColumnResizing
                            enableColumnOrdering
                            enableStickyHeader
                            enableBottomToolbar={true}
                            initialState={{ density: "comfortable" }}
                            muiTableHeadCellProps={{
                                className: "myHeaderSelectAll",
                                sx: {
                                backgroundColor: "#1976d2",
                                color: "white",
                                fontWeight: "bold",
                                },
                            }}
                            muiTableContainerProps={{
                                className: "MaterialTableJs myTableContainer",
                                sx: {
                                maxHeight: 'calc(100vh - 335px)',
                                maxWidth: "100%",
                                overflowX: "auto",
                                borderRadius: "8px",
                                boxShadow: 3,
                                },
                            }}
                            muiTableBodyRowProps={{
                                sx: {
                                '&:nth-of-type(odd)': {
                                    backgroundColor: '#f8fafc !important', // Tailwind slate-50
                                },
                                '&:nth-of-type(even)': {
                                    backgroundColor: '#e0e7ef !important', // Tailwind blue-50
                                },
                            },}}

                            enableGlobalFilter={true}
                            globalFilterFn="contains"
                            columnResizeMode="onEnd"
                            enableRowSelection={false}
                            enableColumnPinning
                            layoutMode="grid"
                            enableHiding={true}
                            displayColumnDefOptions={{
                                "mrt-row-select": { visibleInShowHideMenu: false },
                            }}
                            //manualPagination={true}
                            manualFiltering={false}
                            rowCount={data.length}
                            state={{
                                pagination: pagination,
                            }}
                            onPaginationChange={setPagination}
                            muiTableHeadProps={{
                                className: "myHeader",
                                sx: {
                                    display: "table-header-group",
                                },
                            }}
                            renderTopToolbarCustomActions={({ table }) => (
                                <div>
                                    <h5 style={{ margin: 0 }}>
                                        List of devices discovered ({data.length} records)
                                    </h5>
                                </div>
                            )}
                        /> */}

                        <MaterialReactTable
                            columns={columns}
                            data={data}
                            checkboxSelection={true}
                            enableColumnResizing
                            enableColumnOrdering
                            enableStickyHeader
                            enableBottomToolbar={true}
                            initialState={{ density: "comfortable" }}
                            muiTableHeadCellProps={{
                                sx: {
                                backgroundColor: "#1976d2",
                                color: "white",
                                fontWeight: "bold",
                                },
                            }}
                            muiTableContainerProps={{
                                sx: {
                                maxHeight: 'calc(100vh - 335px)',
                                maxWidth: "100%",
                                overflowX: "auto",
                                borderRadius: "8px",
                                boxShadow: 3,
                                },
                            }}
                            muiTableBodyRowProps={{
                                sx: {
                                '&:nth-of-type(odd)': {
                                    backgroundColor: '#f8fafc !important', // Tailwind slate-50
                                },
                                '&:nth-of-type(even)': {
                                    backgroundColor: '#e0e7ef !important', // Tailwind blue-50
                                },
                                },
                            }}
                            />
                    </div>
                )}
            </div>

            {/* Bulk Edit Modal */}
            <Modal
                show={showAdditionalModal}
                onHide={() => setShowAdditionalModal(false)}
                dialogClassName="DiscoverWidgetModelDiv"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <>
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title">
                            Device Additional Information
                        </Modal.Title>
                        <img
                            src={RemoveIcon}
                            alt="Remove"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setShowAdditionalModal(false);
                            }}
                        />
                    </Modal.Header>

                    <Modal.Body>
                        <form style={{ width: "100%" }}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    borderBottom: "1px solid #ccc",
                                    paddingBottom: "15px",
                                }}
                            >
                                <div className="inputMainContainer w40dot75rem">
                                    <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels">Username</label>
                                        <input
                                            className="inputType"
                                            placeholder="Enter Username*"
                                        />
                                        <p className="Error_P" style={{ float: "left" }}>
                                            <span> { } </span>
                                        </p>
                                    </div>
                                </div>
                                <div className="inputMainContainer w40dot75rem ml-4">
                                    <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels">Password</label>
                                        <input
                                            className="inputType"
                                            placeholder="Enter Password*"
                                        />
                                        <p className="Error_P" style={{ float: "left" }}>
                                            <span> { } </span>
                                        </p>
                                    </div>
                                </div>
                                <Button
                                    className="ml-4"
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    style={{ height: "35px", width: "130px" }}
                                >
                                    Submit
                                </Button>
                            </div>
                            {/* <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
                    <AlertTemplateMessage
                    message={ "Please add username and password to load interface additional data."}
                    />
                </div> */}
                        </form>
                        <div
                            className="DiscoverFormAdditionForm border-top-0"
                            style={{ height: "600px", overflowY: "auto" }}
                        >
                            <div className="device-info-container">
                                {/* Header */}
                                <div className="device-header">
                                    <div className="header-left">
                                        <VideocamIcon sx={{ color: "#1976d2", mr: 1 }} />
                                        <span className="title">
                                            Device Information – 192.168.1.10
                                        </span>
                                    </div>

                                    <div className="header-right connected">
                                        <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />
                                        Connected
                                    </div>
                                </div>

                                {/* Sub Header */}
                                <div className="sub-header">
                                    <span>Manufacturer: Hikvision</span>
                                    <span>Last Sync: 24 Feb 2026</span>
                                </div>

                                {/* ONVIF Status */}
                                <div className="section">
                                    <div className="section-title">
                                        <CheckCircleIcon sx={{ color: "#2e7d32", mr: 1 }} />
                                        Onvif Connection Status
                                    </div>
                                    <div className="section-body">
                                        <p>Connected successfully via Onvif</p>
                                        <p>
                                            Profiles detected: <strong>Profile S, Profile T</strong>
                                        </p>
                                    </div>
                                </div>

                                {/* Device Overview */}
                                <div className="section">
                                    <div className="section-title">
                                        <ListAltIcon sx={{ color: "#455a64", mr: 1 }} />
                                        Device Overview
                                    </div>

                                    <div className="info-box">
                                        <div className="info-row">
                                            <span className="label">Device Name</span>
                                            <span className="value">Entrance Camera 01</span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">Model</span>
                                            <span className="value">DS-2CD2143G0-I</span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">Firmware</span>
                                            <span className="value">v5.6.3</span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">Serial Number</span>
                                            <span className="value">DS2CD2143-XYZ</span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">Onvif Version</span>
                                            <span className="value">2.6</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Network Details */}
                                <div className="section">
                                    <div className="section-title">
                                        <NetworkCheckIcon sx={{ color: "#0288d1", mr: 1 }} />
                                        Network Details
                                    </div>

                                    <div className="info-box">
                                        <div className="info-row">
                                            <span className="label">IP Address</span>
                                            <span className="value">192.168.1.10</span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">HTTP Port</span>
                                            <span className="value">80</span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">RTSP Port</span>
                                            <span className="value">554</span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">Onvif Port</span>
                                            <span className="value">80</span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">MAC Address</span>
                                            <span className="value">00:1A:2B:3C:4D:5E</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Streaming Information */}
                                <div className="section">
                                    <div className="section-title">
                                        <LiveTvIcon sx={{ color: "#6a1b9a", mr: 1 }} />
                                        Streaming Information
                                    </div>

                                    <div className="info-box">
                                        <div className="info-row">
                                            <span className="label">Main Stream</span>
                                            <span className="value">
                                                rtsp://ip:554/Streaming/101
                                                <ContentCopyIcon
                                                    sx={{
                                                        fontSize: 16,
                                                        ml: 1,
                                                        cursor: "pointer",
                                                        color: "#1976d2",
                                                    }}
                                                />
                                            </span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">Sub Stream</span>
                                            <span className="value">
                                                rtsp://ip:554/Streaming/102
                                                <ContentCopyIcon
                                                    sx={{
                                                        fontSize: 16,
                                                        ml: 1,
                                                        cursor: "pointer",
                                                        color: "#1976d2",
                                                    }}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Capabilities */}
                                <div className="section">
                                    <div className="section-title">
                                        <SettingsIcon sx={{ color: "#f57c00", mr: 1 }} />
                                        Capabilities
                                    </div>

                                    <div className="info-box">
                                        <div className="info-row">
                                            <span className="label">Profiles</span>
                                            <span className="value">[ S ] [ T ]</span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">PTZ</span>
                                            <span className="value">
                                                <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                Not Supported
                                            </span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">Events</span>
                                            <span className="value">
                                                <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />
                                                Supported
                                            </span>
                                        </div>

                                        <div className="info-row">
                                            <span className="label">Audio</span>
                                            <span className="value">
                                                <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />
                                                Supported
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <button
                                className="DataAccessEdit mt-3"
                                onClick={() => {
                                    setShowAdditionalModal(false);
                                }}
                                style={{ width: "180px" }}
                            >
                                <span className="ViewUpdate">Device Onboard</span>
                            </button>
                        </div>
                    </Modal.Body>
                </>
            </Modal>
        </div>
    );
};

export default InterfaceDiscoverConfig;
